import React, { useEffect, useState } from "react";
import moment from "moment";
import "./BookingCalendarV2.css";
import {
  BOOKING_ASSIGN_UNASSIGN,
  BOOKING_BY_ID,
  BOOKING_CALENDER_V2,
  BOOKING_FOOTER,
  BOOKING_ROOMS,
  BOOKING_ROOMS_AVL,
} from "../../../../constants/api";
import { displayMessage, getAPI, postAPI } from "../../../../utils/common";
import LayoutHeader from "../../../inc/LayoutHeader";
import LayoutFooter from "../../../inc/LayoutFooter";
import {
  Badge,
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Layout,
  Modal,
  Popover,
  Row,
  Tooltip,
} from "antd";
import BookingStatusWidget from "./widgets/BookingStatusWidgetV2";
import CheckoutModal from "../../CheckoutModal";
import BookingDrawer from "../../BookingDrawer";
import BookingPopOver from "../../BookingPopOver";
import {
  ERROR_MSG_TYPE,
  SUCCESS_MSG_TYPE,
  WARNING_MSG_TYPE,
} from "../../../../constants/messages";
import {
  bookingStatusColors,
  BUSINESS_SEGMENT_IMG,
  capitalizeWords,
  getBookingType,
  getSegmentLabel,
} from "../../../../constants/constent";
import BookingEditModal from "../../BookingEditModal";
import { RedoOutlined } from "@ant-design/icons";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import assets from "../../../../utils/ImagesPath";
dayjs.extend(customParseFormat);

const BookingCalendarV2 = () => {
  const { Content } = Layout;
  const { RangePicker } = DatePicker;

  const [loading, setLoading] = useState(false);
  const [rooms, setRooms] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [dates, setDates] = useState([]);
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(
    moment().add(6, "days").format("YYYY-MM-DD"),
  );
  const [footerStats, setFooterStats] = useState({});
  // Edit Booking Modal
  const [editBookingVisible, setEditBookingVisible] = useState(false);
  // Create Booking Model
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [selectedRoomDate, setSelectedRoomDate] = useState(null);
  // const today = moment();

  const [popoverVisible, setPopoverVisible] = useState(null); // store cell ID (like `${roomId}_${date}`) or `null`

  const getPopoverContent = (info, room_info, date) => (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      <Button
        size="small"
        onClick={() => {
          openModel(info, "popOver");
          setPopoverVisible(null);
        }}
      >
        Booking Detail
      </Button>
      <Button
        size="small"
        type="primary"
        onClick={() => {
          openDrawer(room_info, date);
          setPopoverVisible(null);
        }}
      >
        New Booking
      </Button>
    </div>
  );

  const checkRoomAvl = (room, date) => {
    const formattedCheckIn = moment(date).format("D MMM YY");
    const formattedCheckOut = moment(date).add(1, "day").format("D MMM YY");

    return new Promise((resolve) => {
      const successFn = function (data) {
        if (data.status === true) {
          resolve(true);
        } else {
          displayMessage(ERROR_MSG_TYPE, data.message);
          resolve(false);
        }
      };

      const errorFn = function () {
        displayMessage(ERROR_MSG_TYPE, "Failed to check room availability.");
        resolve(false);
      };

      const url =
        `${BOOKING_ROOMS_AVL}/${room.id}` +
        `/${encodeURIComponent(formattedCheckIn)}` +
        `/${encodeURIComponent(formattedCheckOut)}`;

      getAPI(url, successFn, errorFn);
    });
  };

  const openDrawer = async (room, date) => {
    const isAvailable = await checkRoomAvl(room, date);

    if (!isAvailable) return;

    setSelectedRoom(room);
    setSelectedRoomDate(date);
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedRoom(null);
    setSelectedRoomDate(null);
    fetchCalendarData();
  };

  const [selectedBooking, setSelectedBooking] = useState(null);
  // Booking Detail Model
  const [isBookingPopOverShow, setIsBookingPopOverShow] = useState(false);

  // Booking Checkout Model
  const [isModalVisible, setIsModalVisible] = useState(false);

  const openModel = (info, type) => {
    getBookingDetail(info.id, type);
  };

  const handleClose = () => {
    setIsBookingPopOverShow(false);
    setIsModalVisible(false);
    setSelectedBooking(null);
    fetchCalendarData();
  };

  //
  useEffect(() => {
    const fetchStats = async () => {
      if (rooms.length > 0 && dates.length > 0) {
        const stats = await generateFooterStats();
        console.log("generateFooterStats", stats);
        setFooterStats(stats);
      }
    };

    fetchStats();
  }, [rooms, dates]);

  useEffect(() => {
    fetchCalendarData();
  }, [startDate, endDate]);

  const fetchCalendarData = async () => {
    try {
      setLoading(true);
      const successFn = function (data) {
        if (data.status === true) {
          setRooms(data.data);
          setBookings(data.bookings);
          setDates(generateDateRange(startDate, endDate));
          setLoading(false);
        } else {
          setLoading(false);
          console.error("Failed to fetch calendar data:", data);
        }
      };
      const errorFn = function () {
        setLoading(false);
        console.error("Failed to fetch calendar");
      };

      getAPI(
        BOOKING_CALENDER_V2 + `?start_date=${startDate}&end_date=${endDate}`,
        successFn,
        errorFn,
        {},
      );
    } catch (err) {
      setLoading(false);
      console.error("Failed to fetch calendar data:", err);
    }
  };

  const generateDateRange = (start, end) => {
    const range = [];
    let date = moment(start);
    const endDate = moment(end);

    while (date <= endDate) {
      range.push(date.format("YYYY-MM-DD"));
      date = date.add(1, "day");
    }

    return range;
  };

  const handlePrevWeek = () => {
    const newStart = moment(startDate).subtract(7, "days");
    const newEnd = moment(endDate).subtract(7, "days");
    setStartDate(newStart.format("YYYY-MM-DD"));
    setEndDate(newEnd.format("YYYY-MM-DD"));
  };

  const handleNextWeek = () => {
    const newStart = moment(startDate).add(7, "days");
    const newEnd = moment(endDate).add(7, "days");
    setStartDate(newStart.format("YYYY-MM-DD"));
    setEndDate(newEnd.format("YYYY-MM-DD"));
  };

  const groupRoomsByCategory = (roomsList) => {
    const grouped = {};
    roomsList.forEach((room) => {
      if (!grouped[room.room_category]) {
        grouped[room.room_category] = [];
      }
      grouped[room.room_category].push(room);
    });
    return grouped;
  };

  const groupedRooms = groupRoomsByCategory(rooms);

  const getBookingDetail = (id, type) => {
    const successFn = function (data) {
      if (data.status === true) {
        setSelectedBooking(data.data);
        if (type === "popOver") {
          setIsBookingPopOverShow(true);
          setEditBookingVisible(false);
        } else {
          setIsBookingPopOverShow(false);
          setEditBookingVisible(true);
        }
        setLoading(false);
      } else {
        if (type === "popOver") {
          setIsBookingPopOverShow(false);
        } else {
          setEditBookingVisible(false);
        }
        setLoading(false);
      }
    };
    const errorFn = function () {
      if (type === "popOver") {
        setIsBookingPopOverShow(false);
      } else {
        setEditBookingVisible(false);
      }
      setLoading(false);
    };
    postAPI(BOOKING_BY_ID, { id: id }, successFn, errorFn);
  };

  const generateFooterStats = () => {
    return new Promise((resolve, reject) => {
      const successFn = function (data) {
        if (data.status) {
          resolve(data.data);
        } else {
          console.error("Failed to fetch calendar footer data:", data);
          resolve({});
        }
      };

      const errorFn = function (err) {
        console.error("Failed to fetch calendar footer", err);
        resolve({}); // or reject(err) if you want to handle errors upstream
      };

      getAPI(
        BOOKING_FOOTER + `?start_date=${startDate}&end_date=${endDate}`,
        successFn,
        errorFn,
        {},
      );
    });
  };

  const getContentTemplate = (bookings) => {
    const content = (
      <div
        style={{
          minWidth: 400,
          maxHeight: 600,
          overflowY: "auto",
          paddingRight: 8,
        }}
      >
        {bookings.map((booking) => (
          <div
            key={booking.id}
            style={{
              border: "1px solid #e0e0e0",
              padding: "10px",
              marginBottom: "8px",
              borderRadius: "8px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              backgroundColor: "#fff",
            }}
          >
            <div style={{ fontWeight: "bold" }}>
              {booking.customer_name || "Guest"}
            </div>
            <div style={{ fontSize: "12px", color: "#666" }}>
              Source: {booking.booking_source.toUpperCase()} | Segment:{" "}
              {getSegmentLabel(booking.booking_segment)}
            </div>
            <div style={{ fontSize: "12px", color: "#666" }}>
              Checkin: {moment(booking.checkin_date).format("DD MMM")} |
              Checkout: {moment(booking.checkout_date).format("DD MMM")}
            </div>
            <div style={{ fontSize: "14px", marginTop: 4 }}>
              ₹{booking?.total_with_gst}
            </div>
            <div
              style={{
                marginTop: 8,
                display: "flex",
                gap: "6px",
              }}
            >
              {
                <>
                  <Button block onClick={() => openModel(booking, "edit")}>
                    Edit
                  </Button>
                  <Button
                    block
                    onClick={() =>
                      getRoomByDates(
                        booking.checkin_date,
                        booking.checkout_date,
                        booking.id,
                      )
                    }
                  >
                    {!booking.room_id ? `Assign` : `Change Room`}
                  </Button>
                </>
              }
            </div>
          </div>
        ))}
      </div>
    );
    return content;
  };

  const getBookingsForDate = (date) => {
    const target = moment(date).startOf("day");
    const result = [];

    bookings.forEach((booking) => {
      if (
        booking.booking_status.toString() !== "2" &&
        booking.booking_status.toString() !== "3"
      ) {
        const checkin = moment(booking.checkin_date).startOf("day");
        const checkout = moment(booking.checkout_date).startOf("day");

        if (checkin <= target && target < checkout) {
          result.push(booking);
        }
      }
    });

    return result;
  };

  const getBookingsForCategory = (category) => {
    const result = [];
    bookings.forEach((booking) => {
      if (
        booking.booking_status.toString() !== "2" &&
        booking.booking_status.toString() !== "3" &&
        booking.room_category_title === category &&
        moment(booking.checkout_date).isAfter(moment(startDate), "day")
      ) {
        result.push(booking);
      }
    });

    return result;
  };

  const [groupedRoomsV2, setGroupedRooms] = useState({}); // To store rooms grouped by category
  const [roomSelectionVisible, setRoomSelectionVisible] = useState(false); // State for room selection modal
  const [bookingId, setBookingId] = useState(null); // State for room selection modal

  const getRoomByDates = (checkin_date, checkout_date, id) => {
    const formattedCheckIn = moment(checkin_date).format("D MMM YY");
    const formattedCheckOut = moment(checkout_date).format("D MMM YY");

    // Removed clearData since it's not defined
    const successFn = function (data) {
      if (data.status === true) {
        groupRoomsCategory(data["data"]["rooms"]);
        setRoomSelectionVisible(true);
        setBookingId(id);
      } else {
        setRoomSelectionVisible(false);
      }
    };
    const errorFn = function () {
      setRoomSelectionVisible(false);
    };
    postAPI(
      BOOKING_ROOMS,
      {
        start_date: formattedCheckIn,
        end_date: formattedCheckOut,
      },
      successFn,
      errorFn,
    );
  };

  const groupRoomsCategory = (rooms) => {
    const grouped = rooms.reduce((acc, room) => {
      const category = room.room_category?.title || "Uncategorized";
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(room, ...room.similar_rooms);
      return acc;
    }, {});
    setGroupedRooms(grouped);
  };

  const assignUnassign = async (type, room_id = null) => {
    try {
      setLoading(true);
      const successFn = function (data) {
        if (data.status === true) {
          setLoading(false);
          setGroupedRooms({});
          setRoomSelectionVisible(false);
          setBookingId(false);
          fetchCalendarData();
          displayMessage(SUCCESS_MSG_TYPE, data.message);
        } else {
          displayMessage(ERROR_MSG_TYPE, data.message);
          setLoading(false);
        }
      };
      const errorFn = function () {
        setLoading(false);
      };

      postAPI(
        BOOKING_ASSIGN_UNASSIGN,
        {
          booking_id: bookingId,
          type: type,
          room_id: room_id,
        },
        successFn,
        errorFn,
      );
    } catch (err) {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Failed to assignUnassign" + err);
    }
  };

  // Handle Room Assignment
  const handleAssign = (roomId) => {
    assignUnassign("assign", roomId);
    setRoomSelectionVisible(false); // Close room selection modal
  };

  // -------------------- Helpers --------------------

  const statusMap = {
    0: "🕐 Pending",
    1: "🚪 On Going",
    2: "✅ Completed",
    3: "❌ Cancelled",
    4: "✔️ Accepted, Pending to Check-In",
  };

  const getBookingTooltip = (info) => `
👤 Guest: ${info.customer_name || "N/A"}
🌍 Country: ${info.user?.country?.name || "N/A"}
📅 Check-in: ${moment.parseZone(info.checkin_date).format("YYYY-MM-DD hh:mm A")}
📅 Check-out: ${moment.parseZone(info.checkout_date).format("YYYY-MM-DD hh:mm A")}
💳 Payment: ${info.payment_status === "1" ? "Paid" : "Unpaid"}
🌐 Source: ${getBookingType(info)}
📌 Status: ${statusMap[info.booking_status] || "N/A"}
`;

  const getCellStyle = (info, bgColor) => ({
    backgroundColor: bgColor,
    color: info.booking_status === "1" ? "white" : "black",
    cursor: "pointer",
  });

  const isMultiDayBooking = (room, dates, i, info) => {
    let span = 1;
    let j = i + 1;

    while (
      j < dates.length &&
      room.days[dates[j]]?.status === "booked" &&
      room.days[dates[j]]?.info?.id === info.id
    ) {
      span++;
      j++;
    }

    return span;
  };
  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          loading={loading}
          style={{ padding: 0, margin: 0 }}
          title={<BookingStatusWidget />}
          extra={
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <RangePicker
                allowClear={false}
                value={[dayjs(startDate), dayjs(endDate)]}
                format="YYYY-MM-DD"
                onChange={(dates) => {
                  if (dates?.length === 2) {
                    setStartDate(dates[0].format("YYYY-MM-DD"));
                    setEndDate(dates[1].format("YYYY-MM-DD"));
                  }
                }}
              />

              <Tooltip title="Refresh">
                <Button
                  icon={<RedoOutlined />}
                  loading={loading}
                  disabled={loading}
                  onClick={fetchCalendarData}
                />
              </Tooltip>
            </div>
          }
        >
          <div className="calendar-wrapper">
            <table className="booking-table">
              <thead>
                <tr>
                  <th style={{ minWidth: 10 }}>
                    <button onClick={handlePrevWeek} style={{ marginRight: 8 }}>
                      ←
                    </button>
                    Rooms
                    <button onClick={handleNextWeek} style={{ marginLeft: 8 }}>
                      →
                    </button>
                  </th>

                  {dates.map((date) => {
                    const dateBookings = getBookingsForDate(date);

                    return (
                      <th key={date}>
                        <div>{moment(date).format("DD MMM")}</div>
                        <div>{moment(date).format("ddd")}</div>

                        <Popover
                          content={getContentTemplate(dateBookings)}
                          placement="bottom"
                          trigger="click"
                        >
                          <Badge
                            count={dateBookings.length}
                            style={{
                              backgroundColor: "#52c41a",
                              cursor: "pointer",
                            }}
                          />
                        </Popover>
                      </th>
                    );
                  })}
                </tr>
              </thead>

              <tbody>
                {Object.entries(groupedRooms).map(
                  ([category, roomsInCategory]) => (
                    <React.Fragment key={category}>
                      <tr className="room-category-row">
                        <td>
                          {category.toUpperCase()}{" "}
                          <Popover
                            content={getContentTemplate(
                              getBookingsForCategory(category),
                            )}
                            trigger="click"
                          >
                            <Badge
                              count={getBookingsForCategory(category).length}
                              style={{
                                backgroundColor: "#52c41a",
                                cursor: "pointer",
                              }}
                            />
                          </Popover>
                        </td>
                      </tr>

                      {roomsInCategory.map((room) => (
                        <tr key={room.room_no}>
                          <td className="room-no-cell">
                            {room.room_no} ({room.plan_code})
                          </td>

                          {(() => {
                            const cells = [];
                            let i = 0;

                            while (i < dates.length) {
                              const date = dates[i];
                              const day = room.days[date];
                              const status = day?.status;
                              const info = day?.info;
                              const room_info = day?.room_info;

                              // ---------------- BOOKED ----------------
                              if (status === "booked" && info) {
                                const span = isMultiDayBooking(
                                  room,
                                  dates,
                                  i,
                                  info,
                                );

                                const bgColor =
                                  bookingStatusColors[info.booking_status] ||
                                  "#e0e0e0";

                                const tooltip = getBookingTooltip(info);

                                const isSpecial =
                                  info.booking_status === "2" ||
                                  info.booking_status === "3";

                                const CellWrapper = isSpecial
                                  ? Popover
                                  : React.Fragment;

                                const cellProps = isSpecial
                                  ? {
                                      content: getPopoverContent(
                                        info,
                                        room_info,
                                        date,
                                      ),
                                      title:
                                        info.customer_name || "Booking Options",
                                      trigger: "click",
                                      open:
                                        popoverVisible ===
                                        `${room_info.room_no}_${date}`,
                                      onOpenChange: (visible) =>
                                        setPopoverVisible(
                                          visible
                                            ? `${room_info.room_no}_${date}`
                                            : null,
                                        ),
                                    }
                                  : {};

                                cells.push(
                                  <CellWrapper {...cellProps} key={date}>
                                    <td
                                      colSpan={span}
                                      className={`booked ${
                                        info.payment_status === 0 ||
                                        info.payment_status === null
                                          ? "payment-pending"
                                          : ""
                                      }`}
                                      style={getCellStyle(info, bgColor)}
                                      title={tooltip.trim()}
                                      onClick={
                                        isSpecial
                                          ? undefined
                                          : () => openModel(info, "popOver")
                                      }
                                    >
                                      <div className="booking-cell">
                                        {/* LEFT: segment icon */}
                                        <span className="booking-left-icon">
                                          <img
                                            src={assets.userProfile}
                                            alt="User-Profile"
                                          />
                                        </span>

                                        {/* CENTER: customer name */}
                                        <span className="booking-name">
                                          {capitalizeWords(info.customer_name) || "Booked"}
                                        </span>

                                        {/* RIGHT: status */}
                                        <span className="booking-right-status">
                                          <img
                                            src={
                                              BUSINESS_SEGMENT_IMG[
                                                getBookingType(info)
                                              ] || BUSINESS_SEGMENT_IMG.others
                                            }
                                            alt={getBookingType(info)}
                                            title={getBookingType(info)}
                                          />
                                        </span>
                                      </div>
                                    </td>
                                  </CellWrapper>,
                                );

                                i += span;
                                continue;
                              }

                              // ---------------- EMPTY / AVAILABLE ----------------
                              const bookingMatch = bookings.find(
                                (b) =>
                                  b.room_id === room_info?.id &&
                                  moment(date).isSameOrAfter(
                                    moment(b.checkin_date),
                                    "day",
                                  ) &&
                                  moment(date).isBefore(
                                    moment(b.checkout_date),
                                    "day",
                                  ),
                              );

                              const isAvailable =
                                status === "available" && !bookingMatch;

                              const cellClass =
                                status !== "available"
                                  ? "empty"
                                  : bookingMatch
                                    ? "booked"
                                    : "available";

                              const statusText =
                                status !== "available"
                                  ? "Disabled"
                                  : bookingMatch
                                    ? "Booked"
                                    : "";

                              cells.push(
                                <td
                                  key={date}
                                  className={cellClass}
                                  title={`${room.room_name} - ${
                                    statusText || "Available"
                                  }`}
                                  onClick={() => {
                                    if (!isAvailable) return;

                                    if (
                                      moment(date).isSameOrAfter(
                                        moment(),
                                        "day",
                                      )
                                    ) {
                                      openDrawer(room_info, date);
                                    } else {
                                      displayMessage(
                                        WARNING_MSG_TYPE,
                                        "Oops! You can only book upcoming dates.",
                                      );
                                    }
                                  }}
                                >
                                  {statusText}
                                </td>,
                              );

                              i++;
                            }

                            return cells;
                          })()}
                        </tr>
                      ))}
                    </React.Fragment>
                  ),
                )}
              </tbody>

              {/* ---------------- SUMMARY ---------------- */}
              {[
                "Available Rooms",
                "Rooms Occupied",
                "Occupancy",
                "No. of guests",
                "Arriving",
                "Checking Out",
              ].map((label, index) => (
                <tr key={index} className="summary-row">
                  <td>
                    <strong
                      style={{
                        color:
                          index === 0 || index === 2 || index === 4
                            ? "white"
                            : "black",
                      }}
                    >
                      {label}
                    </strong>
                  </td>

                  {dates.map((date) => {
                    const stat = footerStats?.[date.toString()] || {};

                    const val =
                      index === 0
                        ? stat.available
                        : index === 1
                          ? stat.occupied
                          : index === 2
                            ? `${stat.occupancy || 0}%`
                            : index === 3
                              ? stat.guests
                              : index === 4
                                ? stat.arriving
                                : stat.checkout;

                    return (
                      <td
                        key={date}
                        style={{
                          color:
                            index === 0 || index === 2 || index === 4
                              ? "white"
                              : "black",
                        }}
                      >
                        {val || 0}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </table>
          </div>
        </Card>
        {/* Booking Edit Modal */}
        {editBookingVisible && selectedBooking && (
          <BookingEditModal
            visible={editBookingVisible}
            onClose={handleClose}
            booking={selectedBooking}
          />
        )}
        {/* Pass selected room to the drawer */}
        <BookingDrawer
          open={isDrawerOpen}
          onClose={closeDrawer}
          room={selectedRoom}
          date={selectedRoomDate}
          booking_type={"booking"}
        />
        {/* Checkout Modal */}
        {isModalVisible && selectedBooking && (
          <CheckoutModal
            visible={isModalVisible}
            onClose={handleClose}
            booking={selectedBooking} // Pass the booking data here
          />
        )}
        {/* Detail Modal */}
        {isBookingPopOverShow && selectedBooking && (
          <BookingPopOver
            visible={isBookingPopOverShow}
            onClose={handleClose}
            booking={selectedBooking} // Pass the booking data here
          />
        )}
        {/* Room Selection Modal for Assigning Room */}
        <Modal
          title=""
          visible={roomSelectionVisible}
          onCancel={() => setRoomSelectionVisible(false)}
          footer={null}
          width={500}
          zIndex={100000}
        >
          {Object.keys(groupedRoomsV2).map((category) => (
            <div key={category}>
              <h3>
                <b>{category}</b>
              </h3>
              <Row gutter={16}>
                {groupedRoomsV2[category].map((room) => (
                  <Col span={12} key={room.id}>
                    <Button
                      block
                      onClick={() => handleAssign(room.id)}
                      disabled={loading}
                    >
                      {room.name} ({room.room_no})
                    </Button>
                  </Col>
                ))}
              </Row>
              <Divider />
            </div>
          ))}
        </Modal>
      </Content>
      <LayoutFooter />
    </Layout>
  );
};

export default BookingCalendarV2;
